import { AdornmentType } from 'app/shared/componentsRestyled/coreDesignSystem/form/DataFieldCDS/DataFieldCDS.constants';

import { FieldInputType } from 'constants/fields';
import { MAX_PERCENTAGE_UNLIMITED } from 'constants/number';

export const DEBOUNCE_DELAY_MS = 1000;

export const RATE_DECIMAL_SCALE = 3;

export const BALLOON_TERM_MIN_MONTHS = 1;

export const TOTAL_LOAN_AMOUNT_FEES_KEY = 'redesignedFees';

export const ratePercentInputProps = {
  type: FieldInputType.PERCENTAGE_RESTYLED,
  adornmentType: AdornmentType.END,
  decimalScale: RATE_DECIMAL_SCALE,
  decimalSeparator: '.',
  fixedDecimalScale: true,
  isNumericString: true,
  maxValue: MAX_PERCENTAGE_UNLIMITED,
};

export const DownPaymentFieldName = {
  AMOUNT: 'downPaymentValue',
  PERCENT: 'downPaymentPercent',
};

export const DownPaymentFieldWidthPercent = {
  AMOUNT: 60,
  PERCENT: 40,
};

// HZ-3922: which field the user drove in the down-payment <-> loan-amount sync (see LoanInfo.utils).
export const DOWN_PAYMENT_SYNC_SOURCE = {
  DOWN_PAYMENT: 'downPayment',
  PERCENT: 'percent',
  LOAN: 'loan',
};

// LEN-205: where a chattel refinance's base loan amount comes from, under Loan Details.
export const CHATTEL_REFINANCE_BASE_LOAN_AMOUNT_CAPTION =
  'Base Loan Amount is the payoff of the existing home lien (Liabilities → link it to the subject property and ' +
  'check Pay Off). Without a linked lien it is keyed by hand.';

export const DSCR_MAX = 10;

export const DSCR_DECIMAL_SCALE = 3;

export const PREPAYMENT_PENALTY_TERM_MAX_MONTHS = 60;

export const DSCR_CALCULATED_CAPTION =
  'Leave DSCR blank to calculate it from rent and housing expense.';

// Keys of the loan-info save's groups that the backend accepts as Option patches
// (ApplicationSummaryLoanDetailsPatchDto / ApplicationSummaryLoanAdditionalInfoPatchDto /
// ApplicationSummaryNonQmPatchDto / ApplicationSummaryLoanDocumentVerificationTypesPatchDto).
export const LOAN_DETAILS_PATCH_KEYS = [
  'baseLoanAmount',
  'downPaymentValue',
  'loanPurposeType',
  'escrowSettings',
  'lienPriority',
  'vaTotalEntitlement',
  'buyDownId',
  'miProductType',
  'miPaymentType',
  'miRefundable',
  'miRenewalType',
  'miFinanced',
  'miUpfrontPremiumPercent',
  'miCompanyType',
  'miCompanyOtherDescription',
  'miQuoteIdentifier',
  'miQuoteExpirationDate',
  'miApplicationType',
  'miOrderStatus',
  'miDecisionType',
  'miCertificateIdentifier',
  'miCertificateExpirationDate',
  'miOrderedDate',
  'miDecisionDate',
  'miActivatedDate',
  'miInitialPremiumRatePercent',
  'miInitialPremiumTermMonths',
  'miRenewalPremiumRatePercent',
  'miRenewalPremiumTermMonths',
  'miUpfrontPremiumAmount',
  'miPremiumTaxAmount',
];

// Loan-details patch keys the Loan Info form can derive from another edit, each with the form fields that are the
// user's own edit of it (ApplicationSummaryLoanDetailsPatchDto.Recalculated / LoanDetailsRecalculatedField).
export const LOAN_DETAILS_RECALCULATED_KEY_SOURCES = {
  baseLoanAmount: ['baseLoanAmount'],
  downPaymentValue: ['downPaymentValue', 'downPaymentPercent'],
  loanPurposeType: [
    'loanPurpose',
    'refinancePurpose',
    'cashOutAmount',
    'helocPurpose',
    'additionalLoanSecondMortgageType',
    'additionalLoanDrawAmount',
    'tangibleNetBenefitReason',
    'tangibleNetBenefitCurrentInterestRate',
    'tangibleNetBenefitCurrentAmortizationPeriodMonths',
    'tangibleNetBenefitDescription',
  ],
};

export const LOAN_NON_QM_PATCH_KEYS = [
  'incomeDocumentationType',
  'debtServiceCoverageRatio',
  'prepaymentPenaltyTermMonths',
  'prepaymentPenaltyStructure',
];

export const LOAN_DOCUMENT_VERIFICATION_TYPES_PATCH_KEYS = ['asset', 'employment', 'income'];

export const LOAN_ADDITIONAL_INFO_PATCH_KEYS = [
  'investorCodes',
  'programIdentifiers',
  'leadSourceId',
  'nationalHousingActSection',
  'agencyCaseNumber',
  'agencyCaseNumberIssueDate',
  'governmentRefinancePurpose',
  'hfaInfo',
  'fha203kConsultantId',
  'fhaBorrowerCertification',
];
